import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ComponentsModule } from 'src/app/components/components.module';
import { AppService } from 'src/app/shared/services/app.service';

@Component({
  selector: 'app-request-feature',
  templateUrl: './request-feature.component.html',
  styleUrls: ['./request-feature.component.scss'],
  standalone:true,
  imports :[ CommonModule, ComponentsModule]
})
export class RequestFeatureComponent {
  @Input() isMobile :boolean = false;
  video = ``

  @Input() bgcolor :string ="#fcf7f6";

  constructor(private readonly appService: AppService){}

  ngOnInit(): void {
    
  }

  onSignup() {
    this.appService.navigate('signup', { queryParamsHandling: "merge" });
  }

}
